export const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
export const isValidPhone = (phone) => /^[6-9]\d{9}$/.test(phone);
export const isValidPincode = (pin) => /^\d{6}$/.test(pin);
export const isValidPassword = (pwd) => pwd.length >= 8;

export const validateAddress = (data) => {
  const errors = {};
  if (!data.name?.trim()) errors.name = 'Full name is required';
  if (!isValidPhone(data.phone)) errors.phone = 'Enter a valid 10-digit mobile number';
  if (!data.line1?.trim()) errors.line1 = 'Address is required';
  if (!data.city?.trim()) errors.city = 'City is required';
  if (!data.state?.trim()) errors.state = 'State is required';
  if (!isValidPincode(data.pincode)) errors.pincode = 'Enter a valid 6-digit pincode';
  return errors;
};

export const INDIAN_STATES = [
  'Andhra Pradesh','Arunachal Pradesh','Assam','Bihar','Chhattisgarh','Goa','Gujarat',
  'Haryana','Himachal Pradesh','Jharkhand','Karnataka','Kerala','Madhya Pradesh','Maharashtra',
  'Manipur','Meghalaya','Mizoram','Nagaland','Odisha','Punjab','Rajasthan','Sikkim',
  'Tamil Nadu','Telangana','Tripura','Uttar Pradesh','Uttarakhand','West Bengal',
  'Andaman and Nicobar Islands','Chandigarh','Delhi','Jammu and Kashmir','Ladakh','Lakshadweep','Puducherry',
];

export const US_STATES = [
  'Alabama','Alaska','Arizona','Arkansas','California','Colorado','Connecticut',
  'Delaware','Florida','Georgia','Hawaii','Idaho','Illinois','Indiana','Iowa',
  'Kansas','Kentucky','Louisiana','Maine','Maryland','Massachusetts','Michigan',
  'Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada','New Hampshire',
  'New Jersey','New Mexico','New York','North Carolina','North Dakota','Ohio',
  'Oklahoma','Oregon','Pennsylvania','Rhode Island','South Carolina','South Dakota',
  'Tennessee','Texas','Utah','Vermont','Virginia','Washington','West Virginia',
  'Wisconsin','Wyoming','District of Columbia',
];

/**
 * Per-market address form configuration.
 * dialCode       — phone prefix shown in the UI
 * phonePattern   — regex for local phone digits (without dial code)
 * phoneMaxLength — max chars for phone input
 * postalLabel    — label text (Pincode / ZIP Code)
 * postalPattern  — regex for postal code
 * postalMaxLength— max chars for postal input
 * postalPlaceholder
 * postalDigitsOnly — strip non-digits on input
 * country        — full country name sent to backend
 * stateLabel     — label text for state field
 * states         — dropdown options
 * hasPostalLookup— whether to auto-fill city/state from postal code
 * phoneError     — validation error message
 * postalError    — validation error message
 */
export const MARKET_ADDRESS_CONFIG = {
  IN: {
    dialCode: '+91',
    phonePattern: /^[6-9]\d{9}$/,
    phoneMaxLength: 10,
    postalLabel: 'Pincode',
    postalPattern: /^\d{6}$/,
    postalMaxLength: 6,
    postalPlaceholder: '400001',
    postalDigitsOnly: true,
    country: 'India',
    stateLabel: 'State',
    states: INDIAN_STATES,
    hasPostalLookup: true,
    phoneError: 'Enter a valid 10-digit mobile number',
    postalError: 'Enter a valid 6-digit pincode',
  },
  US: {
    dialCode: '+1',
    phonePattern: /^\d{10}$/,
    phoneMaxLength: 10,
    postalLabel: 'ZIP Code',
    postalPattern: /^\d{5}$/,
    postalMaxLength: 5,
    postalPlaceholder: '10001',
    postalDigitsOnly: true,
    country: 'United States',
    stateLabel: 'State',
    states: US_STATES,
    hasPostalLookup: true,
    phoneError: 'Enter a valid 10-digit US phone number',
    postalError: 'Enter a valid 5-digit ZIP code',
  },
};

/** Returns the address config for the given market code (falls back to IN). */
export const getMarketAddressConfig = (marketCode) =>
  MARKET_ADDRESS_CONFIG[marketCode?.toUpperCase?.()] ?? MARKET_ADDRESS_CONFIG.IN;
